<div class="container">
  <div class="header">
    <h4 mat-dialog-title>Change Context</h4>
  </div>

  <div class="body">
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Accout Id</mat-label>
          <input
            matInput
            placeholder="Enter Account Id"
            [(ngModel)]="accountId"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Channel Id</mat-label>
          <input
            matInput
            placeholder="Enter Channel Id"
            [(ngModel)]="channelId"
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="footer">
    <button
      mat-raised-button
      type="button"
      class="continue"
      (click)="continue()"
    >
      Continue
    </button>
    <button
      mat-stroked-button
      class="mx-3"
      type="button"
      class="skip"
      (click)="close()"
    >
      Close
    </button>
  </div>
</div>
